import { defineSlotRecipe } from "@chakra-ui/react";

const drawerSlotRecipe = defineSlotRecipe({
    slots: [
        "root",
        "backdrop",
        "positioner",
        "content",
        "header",
        "body",
        "footer",
        "title",
        "description",
        "closeTrigger"
    ],
    className: "chakra-drawer",
    base: {
        backdrop: {},
        positioner: {},
        content: {},
        header: {},
        body: {},
        footer: {},
        title: {},
        description: {},
        closeTrigger: {}
    },
    variants: {
        placement: {
            end: {
                content: {
                    _open: {
                        animationName: "slide-from-right-full"
                    },
                    _closed: {
                        animationName: "slide-to-right-full"
                    }
                }
            }
        }
    }
});

export default drawerSlotRecipe;
